import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { CONFIG_CHANGES_RESULT_API, CONFIG_CHANGES_API } from "../../vars";
import { getSortAndFilterQueryString } from "../../view/urlService";
import { ACTION_CONFIGCHANGESRESULT_CHANGED } from "./ConfigChangesPageReducer";


export function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${CONFIG_CHANGES_RESULT_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_CONFIGCHANGESRESULT_CHANGED)({configChangesResult: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}

// export function getDeviceCommand(deviceId) {
//     return securedFetch(`${CONFIG_CHANGES_API}/command/${deviceId}`)
//         .then(response => response.json())
//         .then(data => {
//             // store.dispatch(createAction(ACTION_DEVICES_CHANGED_VALIDATE_PAGE)({devices: data}));
//             // store.dispatch(createAction(ACTION_DEVICES_CHANGED_ANALYSIS_PAGE)({devices: data}));
//             return data;
//         });

// }

export async function getConfigChangesFilesDiff(id1, id2) {
    return securedFetch(`${CONFIG_CHANGES_RESULT_API}/configchangesfiles/?id1=${id1}&id2=${id2}`)
        .then(async response => {
            if (response.ok) {
                const text = await response.text();
                return text ? JSON.parse(text) : null;
            }
            return null;
        })
        .then(data => {
            return data;
        });
}

export async function getFilesDifferences(filesPath) {
    return securedFetch(`${CONFIG_CHANGES_API}/filesdifferences/${filesPath}`)
        .then(async response => {
            if (response.ok) {
                const text = await response.text();
                return text ? JSON.parse(text) : null;
            }
            return null;
        })
        .then(data => {
            return data;
        });
}



export function getFilesDiff(filesPath) {
    return securedFetch(`${CONFIG_CHANGES_API}/filesdiff/${filesPath}`)
        .then(async response => {
            if (response.ok) {
                const text = await response.text();
                return text ? JSON.parse(text) : null;
            }
            return null;
        })
        .then(data => {
            return data;
        });
}

// export async function saveDeviceConfigCommand(configCommand) {
//     return securedFetch(CONFIG_CHANGES_API, configCommand, 'POST')
//         .then(response => response.json());
// }

// export function changeDeviceConfigCommand(parameter) {
//     return securedFetch(CONFIG_CHANGES_API, parameter, 'PUT')
//         .then(response => response.json())
// }

// export function deleteDeviceConfigCommand(idList) {
//     let success = false;

//     for (const id of idList) {
//         success = securedFetch(`${CONFIG_CHANGES_API}/${id}`, null, 'DELETE').then(res => res.ok);
//     }

//     return success;
// }

// export function getConfigFilesByDevice(hostName) {
//     return securedFetch(`${CONFIG_CHANGES_API}/configfiles/${hostName}`)
//         .then(response => response.json())
//         .then(data => {
//             return data;
//         });
// }

// export function getConfigFiles() {
//     return securedFetch(`${CONFIG_CHANGES_API}/configfiles/`)
//         .then(response => response.json())
//         .then(data => {
//             return data;
//         });
// }

// export function getFileContent(filename) {
//     return securedFetch(`${CONFIG_CHANGES_API}/filecontent/${filename}`)
//         .then(response => response.json())
//         .then(data => {
//             return data;
//         });
// }